export const HOME = "/";
export const INGREDIENTS = "/ingredients";
export const CARTRIDGES = "/cartridges";
export const CARTRIDGES_V2 = "/cartridges_V2";
export const DRINKS = "/drinks";
export const I18N = "/i18n"
export const INSTRUCTIONS = "/cartridgeInstructions"
export const ALTERNATIVES = "/alternatives"
